import React, { useState } from 'react';

function ImageUploader({ onImageSelect }) {
  const [preview, setPreview] = useState(null);
  const [agreedToPolicy, setAgreedToPolicy] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!agreedToPolicy) {
      alert('You must agree to the content policy to continue.');
      return;
    }
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
        onImageSelect(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div style={{ marginBottom: '1rem' }}>
      {/* ✅ Checkbox first */}
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ fontSize: '0.9rem' }}>
          <input
            type="checkbox"
            checked={agreedToPolicy}
            onChange={(e) => setAgreedToPolicy(e.target.checked)}
            style={{ marginRight: '0.5rem' }}
          />
          I agree to the{' '}
          <a href="/terms">Terms and Conditions
          </a>{' '}
          and confirm that the selected image will not contain nudity, violence, or exploitative content.
        </label>
      </div>

      {/* ✅ Image input now below checkbox */}
      <h3>Select an Image from your Photos!</h3>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={!agreedToPolicy}
        style={{ opacity: agreedToPolicy ? 1 : 0.5 }}
      />

      {preview && (
        <div style={{ marginTop: '1rem' }}>
          <img src={preview} alt="preview" style={{ width: '150px', borderRadius: '4px' }} />
        </div>
      )}
    </div>
  );
}

export default ImageUploader;

